if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      if (this.querySelector('form')) {
        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      }
      else {
        this.querySelector('[name=id]').disabled = false;
        this.querySelector('button[type=submit]').addEventListener('click', this.onSubmitHandler.bind(this));
      }

      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

      this.hideErrors = this.dataset.hideErrors === 'true';
      
      // Initialize collapsible addons
      this.initCollapsibleAddons();
    }
    
    initCollapsibleAddons() {
        // Use document.querySelectorAll to search entire page
        const headers = document.querySelectorAll('.addon-group-header');

        headers.forEach(header => {
            header.addEventListener('click', function() {
                const targetSelector = this.getAttribute('data-target');
                const targetElement = document.querySelector(targetSelector);
                
                if (targetElement) {
                    const isCollapsed = this.getAttribute('data-collapsed') === 'true';
                    this.setAttribute('data-collapsed', !isCollapsed);
                    targetElement.classList.toggle('expanded');
                }
            });
            
            // Auto-expand the first group
            if (header.parentElement.querySelector('.attachments-grid')) {
                if (!document.querySelector('.attachments-grid.expanded')) { 
                    header.click(); 
                }
            }
        });
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      
      
      if (this.submitButton.getAttribute('aria-disabled') === 'true') {
        return;
      }

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['Content-Type'] = 'application/json'; 
      delete config.headers['X-Requested-With']; 

      // === ADD-ONS LOGIC ===
      
      const formData = new FormData(this.form);
      
      // 1. Get main product data
      const mainVariantId = formData.get('id');
      const mainQuantityInput = this.querySelector('[name="quantity"]');
      const mainQuantity = mainQuantityInput ? parseInt(mainQuantityInput.value, 10) : 1; 
      
      const items = [];

      // Add main product
      items.push({
        id: mainVariantId,
        quantity: mainQuantity 
      });
      
      // 2. Find selected add-ons
      const selectedAddons = document.querySelectorAll('.addon-checkbox:checked');
      
      // Log all addon checkboxes (checked and unchecked) for debugging
      const allAddons = document.querySelectorAll('.addon-checkbox');
      
      selectedAddons.forEach((checkbox, index) => {
        const addonId = checkbox.value;
        
        items.push({
          id: parseInt(addonId, 10), 
          quantity: 1
        });
      });
      
      // 3. Set request body
      config.body = JSON.stringify({ items: items });
      
      
      // === END ADD-ONS LOGIC ===
      
      // Build URL
      let url = `${routes.cart_add_url}`;
      if (this.cart) {
        const sections = this.cart.getSectionsToRender().map((section) => section.id).join(',');
        const sectionsUrl = window.location.pathname;
        url += `?sections=${sections}&sections_url=${sectionsUrl}`;
        this.cart.setActiveElement(document.activeElement);
      }

      fetch(url, config)
        .then((response) => response.json())
        .then((response) => {
          
          if (response.status) {
            console.error('❌ Cart error:', response);
            publish(PUB_SUB_EVENTS.cartError, {source: 'product-form', productVariantId: mainVariantId, errors: response.description, message: response.message});
            this.handleErrorMessage(response.description);
            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form', productVariantId: mainVariantId});
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response); 
          }
          
        })
        .catch((e) => {
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;

      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}